<!-- Health information is told on the picture now, as a flag: this line counts what was made. -->
@if (videoStats().videoCutCount > 0) {
  <span class="inline-flex items-center gap-2">
    <svg mib-icon name="video-cut" class="size-4"></svg>
    <span>{{ videoStats().videoCutCount }}</span>
  </span>
}
